export function transformFeatureStates(data) {
  var _BREEZE_CONTACT_ENRIC, _BREEZE_COMPANY_ENRIC, _BREEZE_SMART_PROPERT;
  const {
    BREEZE_CONTACT_ENRICHMENT,
    BREEZE_COMPANY_ENRICHMENT,
    BREEZE_SMART_PROPERTY
  } = data.featureStates;
  return {
    enrichmentContact: (_BREEZE_CONTACT_ENRIC = BREEZE_CONTACT_ENRICHMENT.isEnabled) !== null && _BREEZE_CONTACT_ENRIC !== void 0 ? _BREEZE_CONTACT_ENRIC : false,
    enrichmentCompany: (_BREEZE_COMPANY_ENRIC = BREEZE_COMPANY_ENRICHMENT.isEnabled) !== null && _BREEZE_COMPANY_ENRIC !== void 0 ? _BREEZE_COMPANY_ENRIC : false,
    smartProperties: (_BREEZE_SMART_PROPERT = BREEZE_SMART_PROPERTY.isEnabled) !== null && _BREEZE_SMART_PROPERT !== void 0 ? _BREEZE_SMART_PROPERT : false
  };
}